import { Box } from '@mui/material';
import { BLUE, BLUE_TERTIARY } from 'constants/colors';

const MAX_VISIBLE_NAMES = 2;

type NamesCellProps = {
  names: string[];
};

const NamesCell = ({ names }: NamesCellProps) => {
  const filled = names.filter(Boolean);
  if (filled.length === 0) return null;
  const visible = filled.slice(0, MAX_VISIBLE_NAMES);
  const overflow = filled.length - MAX_VISIBLE_NAMES;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <span>{visible.join(', ')}</span>
      {overflow > 0 && (
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 22,
            minWidth: 32,
            px: '10px',
            ml: 1,
            borderRadius: '6px',
            boxSizing: 'border-box',
            border: '1px solid',
            borderColor: BLUE,
            backgroundColor: BLUE_TERTIARY,
            color: 'text.primary',
            fontSize: '0.75rem',
            fontWeight: 500,
            flexShrink: 0
          }}
        >
          +{overflow}
        </Box>
      )}
    </Box>
  );
};

export default NamesCell;
